// Registration Constants

export const REGISTRATION_COLLECTION = "registrations";
export const INVITATION_CODES_COLLECTION = "invitationCodes";

export const REGISTRATION_STATUS = {
  CONFIRMED: "confirmed",
  PENDING: "pending",
  FAILED: "failed",
};

// export const REGISTRATION_RESPONSE_CODE = {
//   SUCCESS: "REGISTRATION_SUCCESSFUL",
//   ALREADY_REGISTERED: "USER_ALREADY_REGISTERED",
//   INVALID_INVITATION_CODE: "INVALID_INVITATION_CODE",
//   FAILED: "REGISTRATION_FAILED",
// };

export const REGISTRATION_RESPONSE_CODE = {
  SUCCESS: "REGISTRATION_SUCCESSFUL",
  ALREADY_REGISTERED: "USER_ALREADY_REGISTERED",
  INVALID_INVITATION_CODE: "INVALID_INVITATION_CODE",
  FIRESTORE_ERROR: "FIRESTORE_ERROR",
  FAILED: "REGISTRATION_FAILED",
};